import { useEffect } from 'react';

export const useHomeAnchor = (hash) => {
  useEffect(() => {
    let cancelled = false;
    let frame;
    const positionPage = () => {
      if (cancelled) return;
      frame = requestAnimationFrame(() => {
        if (!hash) {
          window.scrollTo({ top: 0, behavior: 'instant' });
          return;
        }
        const target = document.getElementById(hash.slice(1));
        if (!target) return;
        const headerHeight = document.querySelector('.gg-site-nav')?.getBoundingClientRect().height || 0;
        // Fonts can reflow the hero/card stack after the browser's initial fragment jump.
        // Use one measured offset, not both scroll-padding and scroll-margin.
        const top = target.getBoundingClientRect().top + window.scrollY - headerHeight - 20;
        window.scrollTo({ top: Math.max(0, top), behavior: 'instant' });
      });
    };
    if (hash && document.fonts) document.fonts.ready.then(positionPage);
    else positionPage();
    return () => { cancelled = true; cancelAnimationFrame(frame); };
  }, [hash]);
};